export const SUBSTITUTION_CHARACTER = "{*}"
export const DEFAULT_LANGUAGE = "es"

export type WatchProjectLanguages = "en" | "es"
